const STORAGE_PREFIX = 'tilmicode:last-position';

const buildKey = (userAppId: string | number | null | undefined, courseId: number) =>
    `${STORAGE_PREFIX}:${userAppId ?? 'anonymous'}:${courseId}`;

/**
 * Memorise la derniere leçon ouverte pour un cours donne.
 *
 * La progression en base dit ce qui est termine, pas ou l'eleve se trouvait :
 * apres la validation d'un challenge on retombait donc systematiquement sur le
 * premier chapitre (Introduction). On conserve la position reelle cote client
 * pour pouvoir y revenir.
 */
export const saveLastPosition = (
    userAppId: string | number | null | undefined,
    courseId: number,
    lessonId: number
): void => {
    if (!courseId || !lessonId) return;
    try {
        window.localStorage.setItem(buildKey(userAppId, courseId), String(lessonId));
    } catch {
        // Stockage indisponible (navigation privee, quota) : la position reste
        // deduite de la progression, on ne casse pas la navigation pour autant.
    }
};

export const readLastPosition = (
    userAppId: string | number | null | undefined,
    courseId: number
): number | null => {
    if (!courseId) return null;
    try {
        const raw = window.localStorage.getItem(buildKey(userAppId, courseId));
        const lessonId = Number(raw);
        return Number.isFinite(lessonId) && lessonId > 0 ? lessonId : null;
    } catch {
        return null;
    }
};
